import bike from '../assets/images/delivery-bike.png';
import van from '../assets/images/ifex-van.png';
import truck from '../assets/images/Truck.png';

export const services = [
    {
        title: 'HOUSE TO HOUSE PICKUP',
        serviceImg: bike,
        description: 'We specialise in delivering packages within Nigeria on time and intact. We leverage Technology and Partnerships to build an extensive network of delivery and terminal routes.'
    },
    {
        title: 'HAULAGE',
        serviceImg: van,
        description: 'No matter the size of your item, Ifex will deliver it. We provide organizations with reliable logistics and growing customer support. With over 21 years of credibility and guaranteed delivery.'
    },
    {
        title: 'OVERSEAS SHIPPING',
        serviceImg: truck,
        description: 'We make the world a small place to carry out business and shop from wherever by connecting the foreign markets with a global network reach to make Overseas importation and exportation effortless.'
    }
]